export var extractLatestCommit = function extractLatestCommit(jsonLd) {
  var latestCommit = jsonLd['atlassian:latestCommit'];
  if (typeof latestCommit === 'string') {
    return latestCommit;
  }
  if (latestCommit) {
    //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
  }
};